"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfAnalyticsEventDto = instanceOfAnalyticsEventDto;
exports.AnalyticsEventDtoFromJSON = AnalyticsEventDtoFromJSON;
exports.AnalyticsEventDtoFromJSONTyped = AnalyticsEventDtoFromJSONTyped;
exports.AnalyticsEventDtoToJSON = AnalyticsEventDtoToJSON;
exports.AnalyticsEventDtoToJSONTyped = AnalyticsEventDtoToJSONTyped;
const AnalyticsEventName_1 = require("./AnalyticsEventName");
/**
 * Check if a given object implements the AnalyticsEventDto interface.
 */
function instanceOfAnalyticsEventDto(value) {
    if (!('eventName' in value) || value['eventName'] === undefined)
        return false;
    if (!('properties' in value) || value['properties'] === undefined)
        return false;
    return true;
}
function AnalyticsEventDtoFromJSON(json) {
    return AnalyticsEventDtoFromJSONTyped(json, false);
}
function AnalyticsEventDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'eventName': (0, AnalyticsEventName_1.AnalyticsEventNameFromJSON)(json['eventName']),
        'properties': json['properties'],
    };
}
function AnalyticsEventDtoToJSON(json) {
    return AnalyticsEventDtoToJSONTyped(json, false);
}
function AnalyticsEventDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'eventName': (0, AnalyticsEventName_1.AnalyticsEventNameToJSON)(value['eventName']),
        'properties': value['properties'],
    };
}
//# sourceMappingURL=AnalyticsEventDto.js.map